import styled from 'styled-components'
import { Color } from 'root-constants'
import { SvgImage } from 'components/SvgImage'
import { InputWithValidationIcons } from 'components/InputWithValidationIcons'
import { Button } from 'components/Button'

export const StyledEmailV2 = {
  TitleContainer: styled.header`
    margin-top: 64px;
    margin-bottom: 24px;
  `,
  Title: styled.h1`
    font-weight: 700;
    font-size: 28px;
    line-height: 38px;
    color: ${Color.WHITE};
    text-align: left;
  `,
  Description: styled.p`
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    color: ${Color.WHITE};
    margin-bottom: 40px;
  `,
  Input: styled(InputWithValidationIcons)`
    margin-bottom: 24px;
    background-color: ${Color.WHITE};
  `,
  Disclaimer: styled.p`
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    max-width: 284px;
  `,
  LockIcon: styled(SvgImage)`
    flex-shrink: 0;
    margin-right: 10px;
  `,
  ButtonContainer: styled.div`
    position: relative;
    margin-bottom: 30px;
  `,
  Button: styled(Button)`
    border-radius: 64px;
  `,
}
